import { type FC, memo } from 'react';
import styles from './swap-header.module.scss';
import { useRefreshIcon } from '@hooks/use-refresh';
import onIcon from '@assets/images/deepbook/on.svg';
import offIcon from '@assets/images/deepbook/off.svg';
import Tooltip from '@ui/tooltip';

interface SwapHeaderProps {
  isDeepbookActivity: boolean;
  deepbookActive: boolean;
  onDeepBookActive(active: boolean): void;
}
const SwapHeader: FC<SwapHeaderProps> = (props) => {
  const { onDeepBookActive, deepbookActive, isDeepbookActivity } = props;
  const RefreshView = useRefreshIcon();

  const toggleOn = () => {
    if (isDeepbookActivity) return;
    onDeepBookActive(!deepbookActive);
  };

  return (
    <div className={styles.header}>
      <p className={styles.title}>Trade</p>
      <div className={styles.deepbook}>
        <Tooltip
          visible={isDeepbookActivity ? true : undefined}
          onlyMessage
          overlay="Trade on DeepBook V3 Testnet"
          placement="top"
          overlayStyle={{ zIndex: 800 }}
        >
          <div
            className={`${styles.deepbook_on_off} ${
              deepbookActive ? styles.deepbook_on_off_active : ''
            }`}
            onClick={toggleOn}
          >
            <div className={`${styles.text_on} ${!deepbookActive ? styles.text_hide : ''}`}>ON</div>
            <div className={`${styles.text_off} ${deepbookActive ? styles.text_hide : ''}`}>
              OFF
            </div>
            <div
              className={`${styles.indicator} ${
                deepbookActive ? styles.indicator_on : styles.indicator_off
              }`}
            >
              <img src={deepbookActive ? onIcon : offIcon} data-con />
            </div>
          </div>
        </Tooltip>
      </div>
      <div className={styles.refresh_view}>{RefreshView}</div>
    </div>
  );
};

export default memo(SwapHeader);
